import { Button } from "@chakra-ui/button";
import { Container, Flex, Text } from "@chakra-ui/layout";
import { Link } from "react-router-dom";
import Layout from "../layout/layout";


const Confirmation = (): JSX.Element => {
  return (
    <Layout>
      <Container minH="70vh" maxW="container.xl">
        <Flex
          w="full"
          justifyContent="space-between"
          alignItems={["center", "center", "center", "center", "flex-start"]}
          flexDir={[
            "column-reverse",
            "column-reverse",
            "column-reverse",
            "column-reverse",
            "row",
          ]}
        >
         <Flex flexDir="column" w="full" alignItems="center">
               <Flex mt="20" w="full" alignItems="center" flexDir="column">
                 <Text fontSize="36px" fontWeight="700" textAlign="center">
                    Your order has been placed !<br></br>
                    Please check your email for your receipt.
                </Text>
               <Link to="/shop">
                  <Button
                    bg="#191919"
                    color="#f9fafd"
                    _hover={{ bg: "#363636" }}
                    _active={{ bg: "#191919" }}
                    mt="5"
                    _focus={{}}
                    w="140px"
                  >
                    go back
                  </Button>
                </Link>
              </Flex>
          </Flex>
        </Flex>
      </Container>
    </Layout>
  );
};

export default Confirmation
